import { SerializedError } from "@reduxjs/toolkit";
import { ChipLabelMap, ChipVariantMap } from "../../../shared/components/chips/ValueChip";

export interface User {
  id: string;
  userName: string;
  email: string;
  firstName: string;
  lastName: string;
  loginDate?: Date;
  role: UserRole;
  accessType: AccessTypeCode;
  department?: string;
  expirationDate?: Date;
  visitPurpose?: string;
  status: StatusTypeCode;
}

export enum AccessTypeCode {
  permanent = 1,
  temporary = 2
}

export enum StatusTypeCode {
  active = 1,
  expired = 2,
  disabled = 3
}

export interface UserRole {
  id: string;
  name: string;
}

export interface InviteUser {
  userName: string;
  firstName: string;
  lastName: string;
  department?: string;
  roleId?: string;
}

export interface InviteTemporaryUser {
  userName: string;
  firstName: string;
  lastName?: string;
  visitPurpose?: string;
}

export interface ReinviteUser {
  userId: string;
}

export interface PinRegenerate {
  userId: string;
  visitPurpose: string;
}

export interface EnableUser {
  userId: string;
}

export interface DisableUser {
  userId: string;
}

export interface ChangeUserRole {
  roleId: string;
}

export interface NotificationMessage {
  key: string;
  params?: Record<string, any>;
}

export interface UserState {
  users: User[];
  roles: UserRole[];
  loading: boolean;
  error?: SerializedError;
  success: string | NotificationMessage | undefined;
  sortBy?: number;
  sortDesc: boolean;
}

export const EMPLOYEE_SORT_PARAMETERS = {
  EMPLOYEE: 1,
  DEPARTMENT: 2,
  ACCESS: 3,
  JOINED: 4,
  VALID_UNTIL: 5,
  STATUS: 6,
} as const;

export const createVariantMap = (): ChipVariantMap<AccessTypeCode> => ({
  [AccessTypeCode.permanent]: "contained",
  [AccessTypeCode.temporary]: "outlined"
});

export const createLabelMap = (translate: (key: string) => string): ChipLabelMap<AccessTypeCode> => ({
  [AccessTypeCode.permanent]: translate("employee"),
  [AccessTypeCode.temporary]: translate("temporary")
});